import { Box, Typography } from '@mui/material';
import React__default from 'react';
import { LABEL_LENGTH_TO_WIDTH } from '../../util.js';

var GAP = 2;
var DropdownLabel = function (_a) {
    var _b = _a.minSpace, minSpace = _b === void 0 ? 0 : _b, label = _a.label, value = _a.value;
    return (React__default.createElement(Box, { display: "flex", gap: GAP, justifyContent: "center", alignItems: "center", minWidth: label.length * LABEL_LENGTH_TO_WIDTH + (minSpace ? GAP * 8 : 0) + minSpace },
        React__default.createElement(Typography, { fontSize: 13, color: "neutral300" }, label),
        typeof value === "function" ? (value) : (React__default.createElement(Typography, { fontSize: 14, color: "neutral100" }, value))));
};

export { DropdownLabel };
